import React from 'react'

function IconExternalLink() {
  return <svg className="icon icon--external-link">
    <use xlinkHref="#icon-external-link" />
  </svg>
}

export default IconExternalLink
